export const ReviewFacebookIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0 5.36667C0 3.46836 0 2.51921 0.375289 1.79675C0.69154 1.18794 1.18794 0.69154 1.79675 0.375289C2.51921 0 3.46836 0 5.36667 0H10.6333C12.5316 0 13.4808 0 14.2032 0.375289C14.8121 0.69154 15.3085 1.18794 15.6247 1.79675C16 2.51921 16 3.46836 16 5.36667V10.6333C16 12.5316 16 13.4808 15.6247 14.2032C15.3085 14.8121 14.8121 15.3085 14.2032 15.6247C13.4808 16 12.5316 16 10.6333 16H5.36667C3.46836 16 2.51921 16 1.79675 15.6247C1.18794 15.3085 0.69154 14.8121 0.375289 14.2032C0 13.4808 0 12.5316 0 10.6333V5.36667Z"
        fill="url(#paint0_linear_654_4036)"
      />
      <path
        d="M11.1114 10.2224L11.467 8.00022H9.33366V6.44466C9.33366 5.82244 9.55588 5.33355 10.5337 5.33355H11.5559V3.28911C10.9781 3.20022 10.3559 3.11133 9.7781 3.11133C7.95588 3.11133 6.66699 4.22244 6.66699 6.22244V8.00022H4.66699V10.2224H6.66699V16.0002C7.55588 16.0002 8.44477 16.0002 9.33366 16.0002V10.2224H11.1114Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_654_4036"
          x1="8"
          y1="15.5325"
          x2="8"
          y2="0"
          gradientUnits="userSpaceOnUse">
          <stop stop-color="#0062E0" />
          <stop offset="1" stop-color="#19AFFF" />
        </linearGradient>
      </defs>
    </svg>
  )
}
